import removeTrailingSlash from 'ha/utils/urls/removeTrailingSlash';

export default (nextState, replace, callback) => {
  if (
    // All languages except en should be redirected to closing slash
    ['/de', '/nl', '/es', '/it', '/fr', '/pt', '/zh'].includes(
      nextState.location.pathname,
    )
  ) {
    replace({
      ...nextState.location,
      pathname: `${nextState.location.pathname}/`,
    });
  }

  if (nextState.location.pathname.endsWith('/')) {
    replace({
      ...nextState.location,
      pathname: removeTrailingSlash(nextState.location.pathname),
    });
  }

  callback();
};
